'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.combinedValuesDisplay = exports.singleValueDisplay = undefined;
var _ramda = require('ramda');
var R = _interopRequireWildcard(_ramda);
var _src = require('../../rules/src');
var _constants = require('./constants');
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
var getRefinedMissinParentsLabels = R.pipe(R.propOr([], 'missingParents'), R.reduce(function (acc, par) {
  if (!R.propOr(true, 'display', par) || R.includes(par.id, _constants.REJECTED_VALUE_IDS)) {
    return acc;
  }
  return R.append((0, _src.dimensionValueDisplay)('label')(par), acc);
}, []));
var singleValueDisplay = exports.singleValueDisplay = function singleValueDisplay(display, value) {
  if (display === 'label') {
    return R.converge(function (missingParents, label) {
      return R.isEmpty(missingParents) ? label : R.join(' > ', R.append(label, missingParents));
    }, [getRefinedMissinParentsLabels, (0, _src.dimensionValueDisplay)(display)])(value);
  } else if (display === 'both') {
    return '(' + singleValueDisplay('code', value) + ') ' + singleValueDisplay('label', value);
  }
  return (0, _src.dimensionValueDisplay)(display)(value);
};
var _combinedValuesDisplay = function _combinedValuesDisplay(_display) {
  return function (values) {
    return R.pipe(R.reduce(function (acc, val) {
      if (R.isNil(val)) return acc;
      var isDisplayed = R.propOr(true, 'display', val);
      var isRejected = R.includes(val.id, _constants.REJECTED_VALUE_IDS);
      if ((!isDisplayed || isRejected) && _display === 'label') return acc;
      return R.append(singleValueDisplay(_display, val), acc);
    }, []), function (labels) {
      if (!R.isEmpty(labels) || _display !== 'label') {
        return R.join(', ', labels);
      }
      var totalValue = R.find(R.propEq('id', '_T'), values);
      if (!R.isNil(totalValue)) {
        return (0, _src.dimensionValueDisplay)('label')(totalValue);
      }
      if (R.isEmpty(values)) {
        return '';
      }
      var firstValue = R.head(values);
      return (0, _src.dimensionValueDisplay)('label')(firstValue);
    })(values);
  };
};
var combinedValuesDisplay = exports.combinedValuesDisplay = function combinedValuesDisplay(display, values) {
  if (display === 'both') {
    return R.converge(function (_ids, labels) {
      return (0, _src.dimensionValueDisplay)('both')({
        id: _ids,
        name: labels
      });
    }, [_combinedValuesDisplay('code'), _combinedValuesDisplay('label')])(values);
  }
  return _combinedValuesDisplay(display)(values);
};